import { ClientConfiguration } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";

type SetChatFeatures = { type: 'SET_CHAT_FEATURES'; payload: ClientConfiguration };

export type FeatureAction = SetChatFeatures;

export const setFeaturesAction = (payload: ClientConfiguration): SetChatFeatures => ({ type: 'SET_CHAT_FEATURES', payload });
